// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-border-container__title-wrapper{margin-bottom:16px}.title-border-container__title-wrapper-with-subtitle{margin-bottom:12px}.title-border-container__title-text{letter-spacing:6px}", ""]);
// Exports
module.exports = exports;
